import { useLocation } from 'react-router-dom';
import { ActiveMicrobesContainer } from '@screens/ActiveMicrobes/ActiveMicrobesContainer';
import { useGetMyActiveMicrobes } from '@viome/viome-base/src/usecase/Health/HealthQuery';
import { getQueryParam } from '@/utils/getQueryParam';

export const ActiveMicrobesPage = () => {
  const location = useLocation();
  const type = getQueryParam('type', location.search) || 'gut';
  const { data, isLoading, isError } = useGetMyActiveMicrobes(type);

  if (isError) {
    return (
      <div 
        data-testid="activeMicrobes-error"
        className="dark bg-black h-full w-full flex justify-center items-center"
      >
        <p 
          data-testid="activeMicrobes-errorMessage"
          className="typography-body text-primary"
        >
          Failed to load data. Please try again.
        </p>
      </div>
    );
  }

  return (
    <div 
      data-testid="activeMicrobes-page"
      className="dark bg-black h-full w-full"
    >
      <ActiveMicrobesContainer
        data-testid="activeMicrobes-container"
        activeMicrobes={data}
        isLoading={isLoading || !data}
      />
    </div>
  );
};
